// PlayerProfileService — local mock of the future player profile store.

import { PlayerProfile } from "@/models/types";

const KEY = "adaptivejam.profile";

const DEFAULT_PROFILE: PlayerProfile = {
  level: "Hobbyist",
  knownChords: ["Am", "C", "G", "F", "Em", "Dm"],
  knownPatterns: ["A minor pentatonic — Position 1"],
  preferredGuidance: "FLOW",
  familiarZones: ["A"],
};

export const PlayerProfileService = {
  get(): PlayerProfile {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) return { ...DEFAULT_PROFILE, ...JSON.parse(raw) };
    } catch {
      /* ignore */
    }
    return DEFAULT_PROFILE;
  },

  save(profile: Partial<PlayerProfile>): PlayerProfile {
    const next = { ...this.get(), ...profile };
    localStorage.setItem(KEY, JSON.stringify(next));
    return next;
  },
};
